var novicell = novicell || {};

// Init on document ready
$(function () {
    novicell.Currencyselector.init();
});

novicell.Currencyselector = new function(){


    this.init = function() {
        $(".getcurrency").on('change', function (e) {
            e.preventDefault();
            var val = $(this).val();
   

            var jqxhr = $.get("/?cartcmd=emptycart", function (data) {
            });

            jqxhr.always(function () {
                var jqxhr1 = $.get("/?CurrencyCode=" + val, function (data) {
                });

                jqxhr1.always(function () {
                    location.reload();
                });

            });

        });

        if (typeof iscart !== 'undefined' && iscart !== "" && iscart == "CheckOut") {
            $("body").addClass("CheckOut");
        }
    };


};
